import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import {
  environment,
  WhitelabelState,
  Whitelabel,
  SweetAlertService,
  AuthState,
  Auth,  
  ClearLoginDetails,
  ClearSelectedAddress,
  ClearDeals,
  LocationState,
  FetchLocationList,
  SetLoginFrom
} from '@moduurnv2/libs-orderingapp/src/core';

import { SharedService } from '@moduurnv2/libs-orderingapp/src/core';
import { OrganizationLocationsBaseComponent } from '@moduurnv2/libs-orderingapp/src/features';
import { Store, Select } from '@ngxs/store';
import { ActivatedRoute } from '@angular/router';
import { Subscription, Observable } from 'rxjs';
import { ThemeOptions } from '@moduurnv2/features/ui/directives';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ModalService } from '../../shared/modal/modal.service';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'moduurnv2-organization-locations',
  templateUrl: './organization-locations.component.html',
  styleUrls: ['./organization-locations.component.scss'],
})
export class OrganizationLocationsComponent
  extends OrganizationLocationsBaseComponent
  implements OnInit {
  // locationview = true
  locationSubscription: Subscription;
  openPicker: boolean = false;
  themeOptions: ThemeOptions = {
    appPrimaryColor: true
  };
  @Select(WhitelabelState.getWhitelabel) whitelabel$: Observable<Whitelabel>;
  isMobileView: unknown;

  allowOnlyGuestUsers: boolean = false;

  @Select(AuthState.getCommonAuthDetails) loggedInUserDetails$: Observable<
    Auth
  >;

  userMenuItems = [
    {
      text: 'Profile',
      imageActive: '/assets/images/Profile_Dropdown_Icon_Hover.svg',
      image: '/assets/images/Profile_Dropdown_Icon.svg',
    },
    // {
    //   text: 'Notifications',
    //   imageActive: '/assets/images/Notifications_Dropdown_Icon_hover.svg',
    //   image: '/assets/images/Notifications_Dropdown_Icon.svg',
    // },
    {
      text: 'Payments',
      imageActive: '/assets/images/Payments_Dropdown_Icon_Hover.svg',
      image: '/assets/images/Payments_Dropdown_Icon.svg',
    },
    {
      text: 'Gift/Loyalty Card',
      imageActive: '/assets/images/Points_Dropdown_Icon_Hover.svg',
      image: '/assets/images/Points_Dropdown_Icon.svg',
    },
    // {
    //   text: 'Settings',
    //   imageActive: '/assets/images/Settings_Dropdown_Icon_Hover.svg',
    //   image: '/assets/images/Settings_Dropdown_Icon.svg',
    // },
    {
      text: 'Logout',
      imageActive: '/assets/images/Logout_Dropdown_Icon_Hover.svg',
      image: '/assets/images/Logout_Dropdown_Icon.svg',
    },
  ];

  constructor(
    router: Router,
    sharedService: SharedService,
    store: Store,
    route: ActivatedRoute,
    sweetAlert: SweetAlertService,
    public translate : TranslateService,
    public httpresult: HttpClient,
    modal:ModalService
  ) {
    super(router, sharedService, store, route,sweetAlert,translate,httpresult,modal);
      this.sharedService.display.pipe(takeUntil(this.destroy$)).subscribe(
      (isMobileView) => (this.isMobileView = isMobileView)
    );
    let other = this.store.selectSnapshot(WhitelabelState.getOther);
    if(other && other.paymentGateway && other.paymentGateway.textCode != 'PAYMENTGATEWAY02'){
      this.userMenuItems = this.userMenuItems.filter(function( obj ) {
        return obj.text !== 'Payments';
    });
    }
  }

  getLogo(whitelabel) {
    if(whitelabel) {
      const { restaurantLogo } = whitelabel;
      return  `${environment.imagebaseurl}${restaurantLogo}`;
    }
    return this.logoIcon;
  }

  getSelectedTab(tabName){
   return (tabName == this.selectedTab) ? true : false;
  }

   showRegister() {  
    const authDetails = this.store.selectSnapshot(
      AuthState.getCommonAuthDetails
    );
    authDetails && authDetails.isLoggedIn
          ? this.router.navigate(['user-profile'])
          : this.router.navigate([`login`]); 
    // this.store.dispatch(new setNavigatedfrom("locations"))      
    this.store.dispatch(new SetLoginFrom("locations"))      
  }

  getSeletedMenu(item) {
    if (item && item.text) {
      switch (item.text) {
        case 'Profile':
          this.router.navigate([`/user-profile`]);
          break;
        case 'Payments':
          this.router.navigate([`/payment`]);
          break;
        case 'Gift/Loyalty Card':
          this.router.navigate([`/user-rewards`]);
          break;
        case 'Logout':
          this.store.dispatch(new ClearLoginDetails());
          this.store.dispatch(new ClearSelectedAddress());
          this.store.dispatch(new ClearDeals());
          this.store.dispatch(new FetchLocationList());
          const selectedLocation = this.store.selectSnapshot(
            LocationState.getSelectedLocation
          );
          const { isForceLogin } = this.store.selectSnapshot(
            WhitelabelState.getOther
          );
          console.log(isForceLogin);
          if (isForceLogin) this.router.navigate(['login']);
          else if (selectedLocation)
            this.router.navigate([`locations/${selectedLocation._id}/home`]);
          break;
      }
    }
  }

  
  selectloc(){
    this.locationview = true;
    console.log(this.locationview)
  }
  selectevent(){
    this.locationview = false;
    console.log(this.locationview)

  }
}
